import React, { Component } from 'react';

class ReimpresionTarjeta extends Component {
    render() { 

        const {data,actions,tarjetaReimpresion} = this.props;

        let tituloModal = "Reimpresión"
        let mensajeSuperior = "";

        if(tarjetaReimpresion){
            mensajeSuperior = "¿Confirma la REIMPRESIÓN de la tarjeta " + tarjetaReimpresion.NumeroTarjeta + " del cliente " + tarjetaReimpresion.NombreCliente + "?";
        }

        return (  
        <div className='modalIntegrantesInterior'>
            <div>
                {tituloModal}
            </div>
            <div className='modaReimpresionTarjetaCuerpo'>
                <div>{mensajeSuperior}</div>
                <div className="CuentaSeleccionContainer">
                    <div className='labelAndInfo procesoColumn'>
                        <label>Denominación:</label>
                        <div>{tarjetaReimpresion.DenominacionTarjeta}</div>
                    </div>
                    <div className='labelAndInfo'>
                        <label>4ta. Línea:</label>
                        <div>{tarjetaReimpresion.DenominacionCuartaLinea}</div>
                    </div>
                </div>
                <div className='advertencia-modal-integrante'>El cliente tiene una tarjeta en distribución, consulte... <span className='icono-delivery'></span></div>
            </div>
            <div className='modaConfirmadorBloqueoInteriorFooter'>
                <button onClick={()=>actions.modalSeccion("IntegrantesCuenta","REIMPRESION-TARJETA",false,null,"tarjetaReimpresion")} className='btn btn-secondary'>Cancelar</button>
                <button onClick={()=>null} className='btn btn-cta'>Aceptar</button>
            </div>
        </div>
       );
    }   
}
export default ReimpresionTarjeta;